function uniqueViews(items) {
  const seen = new Set();
  return items.filter((item) => {
    if (seen.has(item.key)) {
      return false;
    }
    seen.add(item.key);
    return true;
  });
}

function view(key, label, description, path, emptyState) {
  return { key, label, description, path, emptyState };
}

export function buildManagerInboxWorkspace(options = {}) {
  const settings = Object.assign({ previousView: null, dashboard: null }, options);
  const views = uniqueViews([
    view("open", "Open Queue", "All open conversations visible to queue supervision.", "/api/conversations?status=open&limit=20", "No open conversations are currently visible."),
    view(
      "overdue",
      "Overdue",
      "Open conversations that need immediate intervention based on queue aging.",
      "/api/conversations?status=open&aging_bucket=overdue&limit=20",
      "No overdue conversations need manager intervention."
    ),
    view("unassigned", "Unassigned", "Open conversations still waiting for ownership.", "/api/conversations/queue/unassigned?limit=20", "No unassigned conversations are waiting in the queue."),
    view("mine", "My Queue", "Conversations currently assigned to your own user.", "/api/conversations/queue/mine?limit=20", "No conversations are currently assigned to you."),
  ]);
  const viewKeys = new Set(views.map((item) => item.key));
  const overdueTotal = Number((((settings.dashboard || {}).sla || {}).overdue_total) || 0);
  const defaultView =
    settings.previousView && viewKeys.has(settings.previousView)
      ? settings.previousView
      : overdueTotal > 0
        ? "overdue"
        : "open";
  return { views, defaultView };
}

export function buildOperatorInboxWorkspace(options = {}) {
  const settings = Object.assign({ previousView: null, triage: null }, options);
  const triage = settings.triage || {};
  const summary = triage.summary || {};
  const focusQueue = triage.focus_queue === "idle" ? "mine" : triage.focus_queue;
  const views = uniqueViews([
    view("mine", "Assigned Leads", "Your active lead queue for reply, outcome, follow-up, and visibility work.", "/api/conversations/queue/mine?limit=20", "You do not have any assigned conversations right now."),
    view(
      "unassigned",
      "Available Leads",
      summary.can_self_assign_unassigned
        ? "Available conversations you can claim when queue policy allows."
        : "Available conversations awaiting assignment. Queue policy currently prevents self-claim.",
      "/api/conversations/queue/unassigned?limit=20",
      "No unassigned conversations are currently available."
    ),
    view(
      "overdue",
      "Overdue",
      "Open conversations currently breaching the queue SLA and needing a reply or disposition.",
      "/api/conversations?status=open&aging_bucket=overdue&limit=20",
      "No overdue conversations are currently visible."
    ),
    view("focus", "Next Lead", triage.focus_reason || "Next best queue based on live triage state.", focusQueue === "unassigned" ? "/api/conversations/queue/unassigned?limit=20" : "/api/conversations/queue/mine?limit=20", "The focus queue is currently empty."),
  ]);
  const viewKeys = new Set(views.map((item) => item.key));
  const defaultView =
    settings.previousView && viewKeys.has(settings.previousView)
      ? settings.previousView
      : focusQueue === "unassigned"
        ? "focus"
        : summary.unassigned_overdue_total > 0
          ? "overdue"
          : "mine";
  return { views, defaultView };
}
